export default "__VITE_ASSET__BfMyeYeF__"